import axios from 'axios';

const creaApi = axios.create({
  baseURL: process.env.REACT_APP_API_CREA
});

creaApi.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export { creaApi };
